import { useMemo } from "react";
import type { AvatarGesture, AvatarLoop } from "./avatar-clips";
import { reactions } from "./reaction-bus";

export type ReactionChoice = { gesture: AvatarGesture } | { hold: AvatarLoop };

type Handlers = {
  onPointerEnter: () => void;
  onPointerLeave: () => void;
  onFocus: () => void;
  onBlur: () => void;
};

/**
 * Handlers that make Orla react while a control is hovered or focused. Keyboard users get
 * the same reaction on focus, so the page behaves the same either way. The choice is
 * compared by its two plain fields, so a fresh object literal on every render is fine.
 */
export function useReaction(reaction: ReactionChoice): Handlers {
  const gesture = "gesture" in reaction ? reaction.gesture : null;
  const hold = "hold" in reaction ? reaction.hold : null;
  return useMemo(() => {
    const start = () => {
      if (gesture) reactions.send({ kind: "gesture", name: gesture });
      if (hold) reactions.send({ kind: "hold", name: hold });
    };
    const stop = () => {
      if (hold) reactions.send({ kind: "release" });
    };
    return { onPointerEnter: start, onPointerLeave: stop, onFocus: start, onBlur: stop };
  }, [gesture, hold]);
}
